import React from 'react';
import InvoiceDetail from 'components/Tvendo/Shopping/Operations/Invoices/InvoiceDetails/InvoiceDetail';

export default function () {
  return <InvoiceDetail />;
}
